import { render, staticRenderFns } from "./DailyImageFolder.vue?vue&type=template&id=0c4336d4&scoped=true&"
import script from "./DailyImageFolder.vue?vue&type=script&lang=js&"
export * from "./DailyImageFolder.vue?vue&type=script&lang=js&"
import style0 from "./DailyImageFolder.vue?vue&type=style&index=0&id=0c4336d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4336d4",
  null
  
)

export default component.exports